import React, { useEffect } from "react"

import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import PatientEN from "./PatientEN"
import PatientSV from "./PatientSV"
import PatientES from "./PatientES"

import "./admin.css"
import "./main.css"

const Patient = () => {

    const accessToken = useSelector((store) => store.user.accessToken)
    const language = useSelector(store => store.user.language)
    
    const navigate = useNavigate()
    
    useEffect(() => {
        if (!accessToken) {
            navigate('/login')
        }
    }, [accessToken, navigate])

    if (language === "en") {
        return (
            <div className="thank-you">
                <PatientEN />
            </div>
        )
    }

    else if (language === "sw") {
        return (
            <div className="thank-you">
                <PatientSV />
            </div>
        )
    }

    else if (language === "es") {
        return (
            <div className="thank-you">
                <PatientES />
            </div>
        )
    }
}

export default Patient